/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrdrServiceSearchHitDto } from './OrdrServiceSearchHitDto';
import {
    OrdrServiceSearchHitDtoFromJSON,
    OrdrServiceSearchHitDtoFromJSONTyped,
    OrdrServiceSearchHitDtoToJSON,
} from './OrdrServiceSearchHitDto';

/**
 * 
 * @export
 * @interface OrdrServiceSearchResponseDto
 */
export interface OrdrServiceSearchResponseDto {
    /**
     * 
     * @type {Array<OrdrServiceSearchHitDto>}
     * @memberof OrdrServiceSearchResponseDto
     */
    hits: Array<OrdrServiceSearchHitDto>;
}

/**
 * Check if a given object implements the OrdrServiceSearchResponseDto interface.
 */
export function instanceOfOrdrServiceSearchResponseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hits" in value;

    return isInstance;
}

export function OrdrServiceSearchResponseDtoFromJSON(json: any): OrdrServiceSearchResponseDto {
    return OrdrServiceSearchResponseDtoFromJSONTyped(json, false);
}

export function OrdrServiceSearchResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdrServiceSearchResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hits': ((json['hits'] as Array<any>).map(OrdrServiceSearchHitDtoFromJSON)),
    };
}

export function OrdrServiceSearchResponseDtoToJSON(value?: OrdrServiceSearchResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hits': ((value.hits as Array<any>).map(OrdrServiceSearchHitDtoToJSON)),
    };
}

